module.exports = __webpack_public_path__ + "static/media/cancelIcon.4f1f7971.svg";